export function stripHtmlTagsAdvanced(html: string): string {
  return html
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '') // удаляет script теги
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '') // удаляет style теги
    .replace(/<[^>]+>/g, '') // удаляет остальные теги
    .replace(/\s+/g, ' ') // заменяет множественные пробелы на один
    .trim()
}
